import { createSimpleSelector } from '../selector-utils';
import { MakeRef } from '../types';
import { createActionsWithReducer } from '../utils';
import { createSingleEntityAdapter } from './adapter';
import {
  SingleEntityState,
  SingleEntityStoreCustomActions,
  SingleEntityStoreOptions,
} from './types';

export function createSingleEntityStore<T extends object>() {
  return <U extends SingleEntityStoreOptions<T>>(namespace: string, options?: U) => {
    const ns = `entity/${namespace}`;

    const baseSelector = createSimpleSelector(
      (root: any) => <SingleEntityState<T>>root[ns],
      state => state,
    );

    const makeRef: MakeRef<T> = (mapFrom, mapTo, source) => ({ mapFrom, mapTo, source });
    const { adapter, initialState, selectors, defaultActions } = createSingleEntityAdapter<T>(
      baseSelector,
      ns,
      options?.references?.(makeRef) || [],
    );

    const mergedActions = <typeof defaultActions & SingleEntityStoreCustomActions<U>>{
      ...defaultActions,
      ...options?.customActions!(adapter),
    };

    const { actions, reducer } = createActionsWithReducer(namespace, initialState, mergedActions);
    return {
      namespace: ns,
      selectors,
      actions,
      reducer,
    };
  };
}
